import DataTable from "react-data-table-component";

import { globalConstants } from "../../../constants";
import { useTranslation } from "react-i18next";
import { translationConstants } from "../../../constants";
import TimezoneDisplayText from "../TimezoneDisplayText/TimezoneDisplayText";

const DataTableComponent = (props) => {
  const { t } = useTranslation();
  const {
    columns,
    items = [],
    responsive = true,
    striped = true,
    highlightOnHover = true,
    pointerOnHover = false,
    dense = false,
    noTableHead = false,
    persistTableHead = true,
    noDataComponent = (
      <div className="w-100 p-2 no-data">
        {t(translationConstants.NO_RECORD_FOUND)}
      </div>
    ),
    disabled = false,
    direction,
    onRowClicked,
    onRowDoubleClicked,
    onRowMouseEnter,
    onRowMouseLeave,
    onColumnOrderChange,
    defaultSortFieldId,
    defaultSortAsc,
    sortIcon,
    sortServer = true,
    onSort,
    selectableRows = false,
    clearSelectedRows = false,
    handleRowSelectionChange,
    expandableRows = false,
    pagination = true,
    paginationServer = true,
    paginationDefaultPage,
    paginationResetDefaultPage,
    paginationTotalRows,
    paginationRowsPerPageOptions,
    onChangePage,
    onChangeRowsPerPage,
    noHeader = true,
    fixedHeader = true,
    handleColumnClick,
    gridState = {
      length: 10,
      pageNumber: 1,
      orderBy: null,
      filterQuery: null,
      search: null,
    },
    customStyles,
    isShowTimezone = false,
  } = props;

  const paginationComponentOptions = {
    rangeSeparatorText: t(translationConstants.rangeSeparatorText),
    rowsPerPageText: t(translationConstants.rowsPerPageText),
  };
  const formattedColumns = columns.map((column) => {
    if (column.sortable) {
      return {
        ...column,
        name: (
          <div
            className="d-flex w-100"
            onClick={() =>
              handleColumnClick ? handleColumnClick(column.id) : null
            }
          >
            <span className="table-header-text-overflow">{column.name}</span>
            <div className="ms-2 d-flex align-items-center">
              {column.sortDirection === null && (
                <i className="fa fa-sort sort-arrows sortable-arrow"></i>
              )}
              {column.sortDirection === globalConstants.SORT.ASC && (
                <i className="fa fa-sort-up sortable-arrow"></i>
              )}
              {column.sortDirection === globalConstants.SORT.DESC && (
                <i className="fa fa-sort-down sortable-arrow"></i>
              )}
            </div>
          </div>
        ),
      };
    } else {
      return column;
    }
  });

  return (
    <div className="w-100 ReactDataTable">
      {isShowTimezone && <TimezoneDisplayText />}
      <DataTable
        columns={formattedColumns}
        data={items}
        responsive={responsive}
        striped={striped}
        highlightOnHover={highlightOnHover}
        pointerOnHover={pointerOnHover}
        dense={dense}
        noTableHead={noTableHead}
        persistTableHead={persistTableHead}
        noDataComponent={noDataComponent}
        disabled={disabled}
        direction={direction}
        onRowClicked={onRowClicked}
        onRowDoubleClicked={onRowDoubleClicked}
        onRowMouseEnter={onRowMouseEnter}
        onRowMouseLeave={onRowMouseLeave}
        onColumnOrderChange={onColumnOrderChange}
        defaultSortFieldId={defaultSortFieldId}
        defaultSortAsc={defaultSortAsc}
        sortIcon={sortIcon}
        sortServer={sortServer}
        onSort={onSort}
        selectableRows={selectableRows}
        clearSelectedRows={clearSelectedRows}
        onSelectedRowsChange={handleRowSelectionChange}
        expandableRows={expandableRows}
        pagination={pagination}
        paginationServer={paginationServer}
        paginationDefaultPage={paginationDefaultPage}
        paginationResetDefaultPage={paginationResetDefaultPage}
        paginationTotalRows={paginationTotalRows}
        paginationPerPage={gridState.length}
        paginationRowsPerPageOptions={paginationRowsPerPageOptions}
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
        noHeader={noHeader}
        fixedHeader={fixedHeader}
        progressPending={false}
        paginationComponentOptions={paginationComponentOptions}
        customStyles={customStyles}
      />
    </div>
  );
};

export default DataTableComponent;
